// extracted by mini-css-extract-plugin
export default {"storeOptionLabel":"StoreSelection_storeOptionLabel__1G+nv","storeOptionText":"StoreSelection_storeOptionText__TCJut"};